import Api from "@/helpers/api.js";

export default {
	addDepot({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.post("/depot", item)
				.then((response) => {
					commit("ADD_DEPOT", Object.assign(item, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchDataListItems({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/depot")
				.then((res) => {
					commit("SET_DEPOTS", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	findById({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.get(`/depot/${itemId}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateItem({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.put(`/depot/${item.id}`, item)
				.then((response) => {
					commit("UPDATE_DEPOT", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/depot/${itemId}`)
				.then((response) => {
					commit("REMOVE_DEPOT", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
